import {
  SET_ELE_TEAM_LOADING,
  SET_ELE_TEAM
} from "./constants";

const initialState = {
  isLoading: true,
  usersData: []
}

const Reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_ELE_TEAM_LOADING:
      return {
        ...state,
        isLoading: payload
      };
    case SET_ELE_TEAM:
      return {
        ...state,
        isLoading: false,
        usersData: payload.usersData
      };
    default:
      return state;
  }
};

export default Reducer;